import {get, post, postJson, imagePost} from '../axios'

const RESOURCE_BASE_PATH = 'dong-dong'

// 获取群组列表
export const getGroupList = p => get(`${RESOURCE_BASE_PATH}/group/list`, p);

// 查询群发记录
export const getGroupRecord = p => postJson(`${RESOURCE_BASE_PATH}/group-chat/marking/record/page`, p);

// 同步商家群数据
export const syncGroup = p => post(`${RESOURCE_BASE_PATH}/group/groupInfoSync`, p);

// 上传图片
export const uploadpic = p => imagePost(`common/uploadPic`, p);

// 保存草稿
export const saveDraft = p => postJson(`${RESOURCE_BASE_PATH}/group-chat/draft/save`, p);

// 获取草稿
export const getDraft = p => get(`${RESOURCE_BASE_PATH}/group-chat/draft/get`, p)

// 提交发送
export const submitGroup = p => postJson(`${RESOURCE_BASE_PATH}/group-chat/marking/submit`, p)
